import { render, staticRenderFns } from "./gather.vue?vue&type=template&id=a95c11ae&"
import script from "./gather.vue?vue&type=script&lang=js&"
export * from "./gather.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports